import { render, staticRenderFns } from "./VideosFeed.vue?vue&type=template&id=4ec351f2&scoped=true&"
import script from "./VideosFeed.vue?vue&type=script&lang=ts&"
export * from "./VideosFeed.vue?vue&type=script&lang=ts&"
import style0 from "./VideosFeed.vue?vue&type=style&index=0&id=4ec351f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec351f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCol,VDivider})
